import { useContext, useEffect, useState } from 'react'
import { Card, Modal } from 'react-bootstrap'
import AdminPicker from '../../../components/AdminPicker/AdminPicker'
import useCallApi from '../../../hooks/useCallApi'
import Advertiser from '../../../templates/Advertiser/Advertiser'
import Loading from '../../../templates/UI/Loading/Loading'
import ReportTable from '../../../templates/ReportTable/ReportTable'
import { useAuth } from '../../../context/AuthContext'
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import AdvertiserRatePitch from '../../../components/AdvertiserRatePitchContent/AdvertiserRatePitchContent'
import queryString from 'query-string'
import CreatePitchModalContent from './CreatePitchModalContent'
import { SystemMessageContext } from '../../../context/SystemMessageContext'

const RatePitchesContent = ({ manager, ignoreManager, dashStatus, defaultAdminId, advertiserId: defaultAdvertiserId }) => {
    const { showSystemMessage } = useContext(SystemMessageContext)
    const [advertiserId, setAdvertiserId] = useState(defaultAdvertiserId)

    const auth = useAuth()

    const location = useLocation()
    let urlParams = queryString.parse(location.search)

    const [showModal, setShowModal] = useState(false)
    const [showCreateModal, setShowCreateModal] = useState(false)
    const [status, setStatus] = useState(dashStatus || "")
    const [adminId, setAdminId] = useState(!manager ? (parseInt(defaultAdminId) > 0 ? parseInt(defaultAdminId) : '') : manager.id)
    const [workingId, setWorkingId] = useState(false)

    let apiUrl = `advertisers/ratePitches?status=${status}`

    if (!ignoreManager) {
        apiUrl += `&adminId=${adminId}`
    }

    if (advertiserId && advertiserId > 0) {
        apiUrl += `&advertiserId=${advertiserId}`
    }

    useEffect(() => {
        //update adminid in url
        const params = new URLSearchParams(window.location.search)
        if (adminId && adminId > 0) {
            params.set('adminId', adminId)
        } else {
            params.delete('adminId')
        }
        const newUrl = `${window.location.pathname}?${params.toString()}`
        window.history.replaceState({}, '', newUrl)
    }, [adminId])




    const { data, setData, dataLoaded, refetch } = useCallApi(apiUrl, 'GET', {}, [adminId, status], showSystemMessage)


    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Advertiser ID',
                accessor: 'advertiser.id',
            },
            {
                Header: 'Advertiser',
                accessor: 'advertiser.name',
                Cell: ({ cell: { value, row } }) => {
                    return <Advertiser name={value} id={row.original.advertiser.id} />
                },
            },
            {
                Header: 'Manager',
                accessor: 'admin.name',
            },
            {
                Header: 'Status',
                accessor: 'status.name',
                Cell: ({ cell: { value } }) => {
                    return <>{(value === 'Open' || value === 'Approved' || value === 'Review' || value === 'Pending' || value === 'Completed') ? <span className="font-weight-bold text-info">{value}</span> : (value === 'Cancelled/Denied' || value === 'Unknown') ? <span className="text-danger">{value}</span> : value}</>
                },
            },
            {
                Header: 'Status Date',
                accessor: 'status.date',
            },
            {
                Header: '',
                accessor: 'id',
                Cell: ({ cell: { value, row } }) => {
                    return (
                        <div className="d-flex justify-content-start">
                            <Link to={`/advertisers/ratePitch/${row.original.id}`} className="btn btn-warning btn-sm my-2" onClick={(e) => { setWorkingId(row.original.id); openModal(e, row.original.id) }}>View</Link>
                        </div>
                    )
                },

            }

        ]

        return (
            <>
                <ReportTable data={data.report} columns={columns} />
            </>
        )
    }

    const openModal = (e, id) => {
        e.preventDefault();
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
        refetch();
    }

    const closeCreateModal = () => {
        setShowCreateModal(false);
        refetch();
    }

    return (
        <Card>
            <Card.Header className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    {
                        !manager ? '' : <h1 className="mb-h1-dark mr-2">Rate Pitches</h1>
                    }
                    <div className="d-flex">
                        {(!manager && !advertiserId) ?
                            <div><AdminPicker defaultSelf adminId={adminId} setAdminId={setAdminId} role={['ADOPS_MANAGER', 'ADOPS_TEAMLEAD', 'MERMGR']} /></div>
                        :
                            'Rate Pitches'
                        }
                        {!dashStatus && dashStatus !== "" &&
                            <select className="form-control form-control-sm ml-2" onChange={(e) => { setStatus(e.target.value) }}>
                                <option value="">All Active</option>
                                <option value="O">Open</option>
                                <option value="R">Review</option>
                                <option value="C">Cancelled</option>
                                <option value="P">Pending</option>
                                <option value="D">Approved</option>
                                <option value="A">Completed</option>
                                <option value="X">Denied</option>
                            </select>
                        }
                    </div>
                </div>
                <button className={`ml-2 btn btn-warning ${!manager > 0 ? '' : 'btn-sm'}`} onClick={() => setShowCreateModal(true)}>Create Rate Pitch</button>
            </Card.Header>
            {
                dataLoaded &&
                    <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} size="sm">
                        <CreatePitchModalContent closeModal={closeCreateModal} initAdvertiser={advertiserId && advertiserId > 0 ? {id: data.advertiser.id, name: data.advertiser.name} : false} />
                    </Modal>
            }
            
            <Modal show={showModal} size="xl" onHide={() => setShowModal(false)}>
                <AdvertiserRatePitch ratePitchId={workingId} refetch={refetch} closeModal={closeModal} />
            </Modal>
            {dataLoaded ? data.report.length === 0 ? <div className="p-3">No rate pitches found.</div> : getReportOutput() : <Loading />}
        </Card>
    )
}
export default RatePitchesContent